import { v4 as uuidv4 } from 'uuid';
import Storage from '@/amplify/storage';
import Logger from '@/common/utils/Logger';

/**
 * Read raw text content from a JSON field URL (S3/CloudFront).
 * Returns empty string on any error.
 * @param {string} jsonUrl
 * @returns {Promise<string>}
 */
export const readJsonFromUrl = async (jsonUrl) => {
    if (!jsonUrl) return '';
    try {
        const url = new URL(jsonUrl);
        if (url) {
            const fetchResponse = await fetch(jsonUrl);
            const jsonText = await fetchResponse.text();
            if (!jsonText || jsonText === 'null' || jsonText === 'undefined') return '';
            return jsonText || '';
        }
        return '';
    } catch (error) {
        Logger.error('readJsonFromUrl err:', error);
        return '';
    }
};

/**
 * Upload JSON content to a temporary S3 path and return the CDN URL.
 * Used during edit/preview before the final save.
 * @param {string} jsonValue - Raw text content
 * @param {string} jsonId - Field ID used to build the tmp path
 * @returns {Promise<string|undefined>} CDN URL or undefined on error
 */
export const handleCreateTmpJsonCdn = async (jsonValue, jsonId) => {
    if (!jsonId) {
        jsonId = `field_${uuidv4()}`;
    }
    try {
        const s3Tmp = `assets/tmp/json/${jsonId}/preview_${uuidv4()}.json`;

        await Storage.put(s3Tmp, jsonValue, {
            contentType: 'application/json',
            level: 'public'
        });

        const previewCdn = `${process.env.REACT_APP_CLOUD_FRONT_URL}/public/${s3Tmp}?v=${Date.now()}`;
        return previewCdn;
    } catch (error) {
        Logger.error('handleCreateTmpJsonCdn err:', error);
    }
};
